import './BlogHero.css';
export default function BlogHero({title,blogType,coverImage}) {
  console.log(blogType);
  return (
     <section className="blog-hero">
      <div className="overlay"></div>
      <div className="hero-content">
        <p className="category">{blogType}</p>
        <h1>{title}</h1>
        <div className="meta">
          {/* <span>By MotouraX Team</span>
          <span>•</span>
          <span>October 15, 2025</span>
          <span>•</span>
          <span>5 min read</span> */}
        </div>
      </div>
    </section>
  )
}